/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Theme } from '@mui/material'

interface AdminPageContainerProps {
  theme: Theme
}

export const rolesList = css`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
`

export const roleListItem = css`
  width: 64px;
`

export const AdminPageContentContainer = ({ theme }: AdminPageContainerProps) => css`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  max-width: 1800px; // Something fairly wide just to cap wide screens
  padding: ${theme.spacing(12)};
`

export const AdminPageContainer = ({ theme }: AdminPageContainerProps) => css`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;

  width: 100%;
  height: 100svh;
  min-height: 100%;

  overflow: auto;

  margin: 0 auto;
  background-color: ${theme.palette.primary.main}18;
`

export const formWrapper = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const dashboardWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  margin-top: 24px;

  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }
`

export const headerSection = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 8px;
`

export const metricsSection = css`
  margin-top: 8px;
  display: flex;
  gap: 16px;

  & > div {
    width: 25%;
  }
`

export const clientLogoStyle = css`
  height: 40px;
  width: auto;
  object-fit: contain;
`

export const tabsSection = css`
  background: white;
  border-radius: 4px;
  padding: 16px 0;
`

export const containerWrapperCard = ({ theme }: AdminPageContainerProps) => css`
  display: flex;
  flex-direction: row;
  gap: 25px;

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`

export const tabContent = css`
  padding: 24px 0;
  min-height: 200px;
`

export const infoContainer = ({ theme }: AdminPageContainerProps) => css`
  width: 50%;
  min-height: 300px;

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const cardTitle = css`
  color: #2263b0;
  margin-bottom: 4px;
  font-weight: 600;
`
export const metricCard = () => css`
  border-radius: 4px;
  height: 160px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: white;
  width: 100%;
`
export const cardContent = css`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    transition: background-color 0.3s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }
`

export const formPaperStyle = css`
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
`

export const formTitleStyle = (primaryDark: string) => css`
  color: ${primaryDark};
`

export const formDescriptionStyle = (primaryDark: string) => css`
  color: ${primaryDark};
  padding-bottom: 16px;
`

export const formInputContainerStyle = css`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
  padding-bottom: 8px;
`

export const formTextFieldStyle = css`
  width: 100%;
`

export const formHelperTextStyle = (primaryDark: string) => css`
  color: ${primaryDark};
  font-size: 11px;
  font-style: italic;
  margin-top: 4px;
  padding-bottom: 8px;
`

export const validationErrorStyle = css`
  margin-top: 16px;
`

export const drawerActionsStyle = css`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

export const headerButtonsContainerStyle = css`
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: flex-end;
`

export const listContainer = css`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
  }
`

export const rolesFormWrapper = () => css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  & > div {
    width: 50%;
  }
  margin-top: 24px;
`
export const drawerInner = css`
  overflow-y: auto;
`

export const loadingWrapper = css`
  display: flex;
  justify-content: center;
  align-tems: center;
`

export const table = css`
  margin: 0;
`
export const roleRow = css`
  width: 120px;
`

export const descriptionRow = css`
  width: 320px;
`

export const editButtonRow = css`
  width: 120px;
`

export const defaultBodyRow = css`
  height: 60px;
`

export const roleBodyRow = css`
  padding: 8px 16px;
  width: 120px;
  height: 60px;
`

export const descriptionBodyRow = css`
  padding: 8px 16px;
  width: 320px;
`

export const editBodyRow = css`
  padding: 8px 16px;
`

export const deleteBodyRow = css`
  padding: 8px 16px;
`
export const drawerWrapper = css`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const temporaryRoleToast = css`
  padding-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-top: -16px;
`

export const temporaryRoleWrapper = css`
  border-top: 1px solid #d9d9d9;
  margin-top: 24px;
  padding-top: 24px;
`

export const autocompleteWrapper = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 8px;
`

export const autocompleteCustom = css`
  width: 100%;
`

// Layer Permissions
export const errorLayerPermissions = css`
  padding-top: 32px;
  padding-left: 16px;
`

export const layerPermissionsWrapper = css`
  margin-top: 24px;
  width: 100%;
`

export const layerPermissionsHeader = css`
  margin-top: 28px;
`

export const layerPermissionsHeaderInner = ({ theme }: AdminPageContainerProps) => css`
  padding: 16px;
  margin-bottom: 24px;
  background-color: ${theme.palette.background.default};
`

export const layerPermissionsTypography = ({ theme }: AdminPageContainerProps) => css`
  color: ${theme.palette.primary.dark};
`
export const layerPermissionsTypographyUpper = ({ theme }: AdminPageContainerProps) => css`
  color: ${theme.palette.primary.dark};
  margin-bottom: 8px;
`
export const layerPermissionsTabsWrapper = css`
  padding-top: 16px;
`

export const layerPermissionsDivider = css`
  border-color: #d9d9d9;
`

export const layerPermissionsTable = css`
  min-width: 650px;
`
